var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('ApolloQuery',{attrs:{"query":_vm.seedQuery,"variables":{ id: _vm.id }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var error = ref_result.error;
var data = ref_result.data;
return [_c('h1',[_vm._v(_vm._s(data.seed.name)+" ("+_vm._s(data.seed.user.name)+")")]),_c('p',[_vm._v(" "+_vm._s(data.seed.description)+" ")]),_c('em',[_vm._v(_vm._s(data.seed.type))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }